var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f2g-color-picker"},[_c('InputColorPicker',{ref:"inputColorPicker",staticClass:"f2g-color-picker-input",class:{ 'f2g-color-picker-input-disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }